import { put, takeLatest } from 'redux-saga/effects'
import queryString from 'query-string'
import { submitPasswordReset as submit } from '../api/passwordReset'
import {
  submitPasswordResetSucceeded,
  submitPasswordResetFailed
} from '../../actions/passwordReset'
import { SUBMIT_PASSWORD_RESET } from '../../constants/action.types'
import executeSaga from './helpers/executeSaga'

export function* submitPasswordReset({ request }, action) {
  const { email, recaptchaResponse } = action.payload
  const data = {
    user_email: email,
    'g-recaptcha-response': recaptchaResponse
  }

  yield executeSaga(
    request,
    queryString.stringify(data),
    () => put(submitPasswordResetSucceeded()),
    () => put(submitPasswordResetFailed())
  )
}

export default function*({ request } = { request: submit }) {
  yield takeLatest(SUBMIT_PASSWORD_RESET, submitPasswordReset, { request })
}
